import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { ErrorStateProps } from '../../types';
import { popupStyles } from '../styles/popupStyles';

const styles = (theme: any) => ({
  errorContainer: popupStyles(theme).errorContainer,
  errorMessage: popupStyles(theme).errorMessage,
  noData: popupStyles(theme).noData,
});

const ErrorState: React.FC<ErrorStateProps & { classes: any }> = ({ 
  classes, 
  error, 
  onRetry, 
  retryButtonText = 'Retry' 
}) => {
  return (
    <div className={classes.errorContainer}>
      <div className={classes.errorMessage}>
        {error}
      </div>
      {onRetry && (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={onRetry}
        >
          {retryButtonText}
        </Button>
      )}
    </div>
  );
};

export default withStyles(styles)(ErrorState);
